import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Paper,
  Card,
  CardHeader,
  Avatar,
  CardContent,
  Typography,
} from "@material-ui/core";
import {
  red,
  pink,
  lightGreen,
  grey,
  lightBlue,
} from "@material-ui/core/colors";
import { getInitial, colorPicker } from "./helper";

const useStyles = makeStyles((theme) => ({
  gridRoot: {
    display: "flex",
    flexWrap: "wrap",
    margin: "2rem 2rem",
  },
  paper: {
    margin: "0 auto",
    minHeight: "200px",
    minWidth: "90%",
  },
  cardRoot: {
    maxWidth: 345,
    margin: "0 auto",
    transition: "transform .2s",
    "&:hover": {
      boxShadow: "0 10px 10px #777",
      transform: "scale(1.1)",
    },
  },
  media: {
    opacity: "0.6",
    marginLeft: "2px",
    paddingTop: "2%", // 16:9
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
}));

function CardComponent(props) {
  const { firstName, lastName, date, position, company, comment, img } = props;
  const classes = useStyles();
  const colorArr = [red, pink, lightGreen, grey, lightBlue];
  return (
    <Grid item xs={6} sm={3} className={classes.gridRoot}>
      <Paper className={classes.paper} elevation={3}>
        <Card className={classes.cardRoot}>
          <CardHeader
            avatar={
              <Avatar
                aria-label="person"
                style={{ backgroundColor: `${colorPicker(colorArr)[500]}` }}
              >
                {" "}
                {getInitial(firstName, lastName)}
              </Avatar>
            }
            title={`${firstName} ${lastName} (${position}) - ${company}`}
            subheader={date}
          />
          <img className={classes.media} src={img} alt='quoteIcon'/>
          <CardContent>
            <Typography variant="body1" color="textSecondary" component="p">
              {comment}
            </Typography>
          </CardContent>
        </Card>
      </Paper>
    </Grid>
  );
}

export default CardComponent;
